import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RicercaElementiService extends JwtService{

  constructor(
    private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }
  filterNews(searchTerm, pageNum): Promise<any> {
    console.log("Chiamo il backend con:", searchTerm);
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/articoli/cerca/'+ searchTerm +'?pageNumber='+ pageNum +'&pageMaxElement=12', 
      super.getOptions()).toPromise().then( res => res).catch(this.handleError.bind(this));
  }
  filterDocs(searchTerm, pageNum): Promise<any> {
    console.log("Chiamo il backend con:", searchTerm);
    return this.http.get(environment.apiEndpoint + '/CentroFunzionalePortaleRest/rest/documenti/cerca/'+ searchTerm +'?pageNumber='+ pageNum +'&pageMaxElement=12', 
      super.getOptions()).toPromise().then( res => res).catch(this.handleError.bind(this));
  }
}

